export default function ProgressBar({ answered, total }) {
  const pct = total > 0 ? (answered / total) * 100 : 0;

  let barColor = "bg-slate-300";
  if (pct > 0 && pct < 100) barColor = "bg-blue-600";
  if (pct === 100) barColor = "bg-emerald-500";

  return (
    <div className="h-1 w-full bg-slate-100">
      <div
        className={`h-full rounded-r-full transition-all duration-300 ${barColor}`}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
